import * as THREE from 'three';

export function createWireframeMaterial(color: number, opacity: number): THREE.MeshBasicMaterial {
  return new THREE.MeshBasicMaterial({
    color,
    wireframe: true,
    transparent: true,
    opacity,
    depthWrite: true,
  });
}

/** Linearly interpolates between two colors (hex numbers or CSS hex strings). */
export function lerpColor(
  from: THREE.ColorRepresentation,
  to: THREE.ColorRepresentation,
  t: number,
): THREE.Color {
  const a = new THREE.Color(from);
  const b = new THREE.Color(to);
  return a.lerp(b, Math.min(1, Math.max(0, t)));
}

/** Creates a small radial-gradient canvas texture used for glowing point sprites. */
export function createGlowSpriteTexture(): THREE.CanvasTexture {
  const canvas = document.createElement('canvas');
  canvas.width = 32;
  canvas.height = 32;
  const ctx = canvas.getContext('2d')!;
  const gradient = ctx.createRadialGradient(16, 16, 0, 16, 16, 16);
  gradient.addColorStop(0, 'rgba(255,255,255,1)');
  gradient.addColorStop(0.08, 'rgba(200,240,255,0.9)');
  gradient.addColorStop(0.25, 'rgba(100,200,255,0.55)');
  gradient.addColorStop(0.5, 'rgba(30,120,220,0.15)');
  gradient.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 32, 32);

  const texture = new THREE.CanvasTexture(canvas);
  texture.needsUpdate = true;
  return texture;
}
